/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * IS_NOT_NULL operator looks for values in the given key that are not null.
 */
export interface KeyIsNotNullLabelKey {
    /** The key to compare against. */
    key: string;
}
